import React, { useState } from 'react'
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core'
import { useStyles} from '../BrowserStyle'
import Chip from '@material-ui/core/Chip';
import AttachmentOutlinedIcon from '@material-ui/icons/AttachmentOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ImageDialog from './DialogImage';
import Divider from '@material-ui/core/Divider';
import { isBrowser } from 'react-device-detect';

export const RadioGroupControl = ( { respuestas, archivos_respuesta, preg, handleChange } ) => {
    const classes = useStyles()
    const [isOpen, setIsOpen] = useState(false);
    const [filtro, setFiltro] = useState({ pregunta: 0, respuesta: 0 });
    const [selectedValue, setSelectedValue] = useState(''); // agregado rvel 06.05.2023

    const handleOpen = ( objeto ) => {
        setIsOpen(!isOpen);
        setFiltro(objeto);
    };

  

    return (
        <>
		<table>
           
            <FormControl component="fieldset">
			<tr>
                {/* <RadioGroup column={!isBrowser} row={isBrowser} */}
              <RadioGroup  column={ true }
				// <RadioGroup column={!isBrowser} row={isBrowser} column={ true }
               // <RadioGroup column={ true }>
            //    value={selectedValue}//agregado rvel 06.05.2023
                name={ preg.ID } onChange={ ( e ) => handleChange( e, preg.ID ) } className={ classes.radioStyle }>
                    {
                        respuestas.filter( rpta => rpta.ID_PREGUNTA === preg.ID )
                        .map( rpta => (
                            
                            <>
                                <div className={ isBrowser && classes.align_items_middle }>
								   <tbody>
									<tr>
                                   
                                   
    <FormControlLabel
      value={preg.ID + '_' + rpta.ID}
      name={preg.ID + '_' + rpta.ID}
      control={<Radio color="primary" />}
      label={rpta.DESCRIPCION}
     // style={rpta.ID === '2751' ? { opacity: 0 } : {opacity: 0}}
      // Puedes añadir el estilo para hacerlo invisible aquí si ese es el objetivo final,
      // pero ten en cuenta que el control se crea de todas formas si la condición es true.
      // style={{ opacity: 0 }}
    />

									
									</tr>
								<tr>
									
										
										<div className="ed-grid s-grid-1">
                                        { rpta.NOTA_RESPUESTA} 
                                    
                                        
										
                                    </div>
									</tr>
									</tbody>
									
									
                                    {
                                        rpta.IND_IMAGEN != '0'
                                        &&
                                        <Chip
                                            icon={<InfoOutlinedIcon />}
                                            label="Imagen"
                                            clickable
                                            color="primary"
                                            variant="outlined"
                                            size="small"
                                            onClick={ () => handleOpen( { pregunta: preg.ID, respuesta: rpta.ID } ) }
                                            // onDelete={handleDelete}
                                        />
                                    }
                                </div>
                                {
                                    (!isBrowser)
                                    &&
                                    <Divider variant="middle" style={{ marginTop: '7px', marginBottom: '12px' }} />
                                }
                            </>
                        ) )
                    }
                </RadioGroup>
				</tr>
            </FormControl>
			</table>
            <ImageDialog
            isDialogOpened={isOpen}
            filtro={filtro}
            listaArchivos={archivos_respuesta}
            handleCloseDialog={() => setIsOpen(false)}
            tipo="respuesta"
            />
        </>
    )
}
